import React from 'react';
import { Query } from 'react-apollo';

import GqlWrapper from '../GqlWrapper/GqlWrapper';
// import { ALL_ETFS_QUERY } from '../../containers/ETFResearchTool/queries';
import { isLowerEnvironment } from '../../config';

import MOCK_DATA from './MockData/MockData';

const GqlQueryWrapper = ({
    query,
    variables,
    dataFunc,
    filter,
    gqlFilter,
    placeholder,
    render,
    children,
    skip,
    skipWithChildren,
    unbatch = false
}) =>
    skipWithChildren ? (
        children({ data: dataFunc ? dataFunc() : {} })
    ) : (
        <Query
            skip={skip}
            query={query}
            variables={variables}
            context={{ unbatch }}
            // errorPolicy={query === ALL_ETFS_QUERY ? 'ignore' : 'none'}
            errorPolicy="ignore"
        >
            {(gqlResponse) => {
                const mockKey = `${query.definitions[0].name.value}Mock`;
                const queryParams = new URLSearchParams(window.location.search);
                const shouldMock =
                    queryParams.get('test') &&
                    isLowerEnvironment(window.location.host) &&
                    Object.keys(MOCK_DATA).includes(mockKey);
                let response;

                if (shouldMock) {
                    response = {
                        ...gqlResponse,
                        data: {
                            ...MOCK_DATA[mockKey]
                        }
                    };
                } else {
                    response = gqlResponse;
                }

                return (
                    <GqlWrapper
                        dataFunc={dataFunc}
                        gqlFilter={gqlFilter}
                        filter={filter}
                        placeholder={placeholder}
                        render={render}
                        {...response}
                    >
                        {children}
                    </GqlWrapper>
                );
            }}
        </Query>
    );

export default GqlQueryWrapper;
